import { Navigate, useRouteLoaderData } from 'react-router';
import { paths } from '../../../../../common/constants/pathVariables.js';
import { useSearchParams } from '../../../../../common/hooks/useSearchParams.js';
import { ServiceBillingAccountDetails } from '../../../../../components/SubscriptionDetails/ServiceBillingAccountDetails.js';
import { getSubscriptionUrl } from '../../../../../components/SubscriptionLayout/MobileSubscriptionLayout.js';
import { ServiceSubscriptionLayout } from '../../../../../components/SubscriptionLayout/ServiceSubscriptionLayout.js';
import { isPbxServiceSubscription } from '../../../../../components/SubscriptionLayout/serviceSubscriptionLayoutUtils.js';
import type { ServiceSubscriptionLoaderResponse } from '../../../../../common/loaders.js';

export const ServiceBillingAccountUserInformationPath = () => {
  const { companyInfo, subscription } = useRouteLoaderData('serviceSub') as ServiceSubscriptionLoaderResponse;
  const { mdmId } = useSearchParams<{ mdmId: string }>();

  if (isPbxServiceSubscription(subscription)) {
    return <Navigate replace to={getSubscriptionUrl(paths.PS_SERVICE, subscription, mdmId ?? '')} />;
  }

  return (
    <ServiceSubscriptionLayout companyInfo={companyInfo} subscription={subscription}>
      <ServiceBillingAccountDetails companyInfo={companyInfo} subscription={subscription} />
    </ServiceSubscriptionLayout>
  );
};
